"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.VIEW_OPTIONS = exports.SEGMENT = exports.PHONE_COLORS = exports.KIND = void 0;

var _react = _interopRequireWildcard(require("react"));

var _gerenciatdUnifiedcomponents = _interopRequireWildcard(require("@bit/gerenciatd.unifiedcomponents.button"));

var _gerenciatdUnifiedcomponents2 = _interopRequireWildcard(require("@bit/gerenciatd.unifiedcomponents.text-info"));

var _gerenciatdUnifiedcomponents3 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.custom-link"));

var _gerenciatdUtils = require("@bit/gerenciatd.utils.common");

var _gerenciatdUtils2 = require("@bit/gerenciatd.utils.environment");

var _gerenciatdUtils3 = require("@bit/gerenciatd.utils.tagging");

var _gerenciatdUnifiedicons = _interopRequireWildcard(require("@bit/gerenciatd.unifiedicons.svg-icon-loader"));

var _gerenciatdUnifiedicons2 = require("@bit/gerenciatd.unifiedicons.svg-icon-label");

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./call4selling.scss");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const COMPONENT_NAME = 'Call4Selling';
const PHONE_COLORS = {
  WHITE: 'white',
  BLACK: 'black',
  GREEN: 'green',
  BLUE: 'blue',
  GREY: 'grey',
  GREEN_REVERSE: 'green_reverse',
  BLUE_REVERSE: 'blue_reverse',
  GREY_REVERSE: 'grey_reverse',
  RED: 'red',
  RED_REVERSE: 'red_reverse',
  PURPLE: 'purple'
};
exports.PHONE_COLORS = PHONE_COLORS;
const VIEW_OPTIONS = {
  BUTTON: 'button',
  PHONE: 'phoneNumber'
};
exports.VIEW_OPTIONS = VIEW_OPTIONS;
const SEGMENT = {
  GP: 'gp',
  EMP: 'emp'
};
exports.SEGMENT = SEGMENT;
const KIND = {
  PHONE: 'telefono',
  C2C: 'c2c'
};
exports.KIND = KIND;

class Call4Selling extends _react.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "componentDidMount", () => {
      const {
        applySam,
        samActions,
        kind,
        visible
      } = this.state;

      if (applySam && window && window.IC && window.IC.evaluate) {
        window.IC.evaluate('SCX', () => {
          this.setState({
            // Si no viene niguna regla de SA2M, window.sa2mAction es undefined, así que forzamos a mostrar los 900 si no hay ninguna regla.
            samActions: window.sa2mAction || {
              900: 'show',
              c2c: 'show'
            }
          }, () => {
            if ((kind === KIND.PHONE && samActions['900'] === 'show' || kind === KIND.C2C && samActions.c2c === 'show') && visible) {
              this.checkAndSubscribeToSCX();
            }
          });
        });
      } else if ((kind === KIND.PHONE && samActions['900'] === 'show' || kind === KIND.C2C && samActions.c2c === 'show') && visible) {
        this.checkAndSubscribeToSCX();
      }
    });

    _defineProperty(this, "changeState", () => {
      const {
        kind
      } = this.state;

      if (kind === KIND.PHONE) {
        const current900 = this.get900();
        const {
          virtual900
        } = this.state;

        if (virtual900 !== current900) {
          this.setState({
            virtual900: current900
          });
          this.comunicate900Printed(current900);
        }
      }

      if (kind === KIND.C2C) {
        this.setState({
          ScxLoaded: true
        });
      }
    });

    _defineProperty(this, "checkAndSubscribeToSCX", () => {
      window.nookInfoExchange.registerAsObserver('SCX-Status', `Call4Selling_${Math.random()}`, data => {
        if (this.printStates.indexOf(data.status) !== -1) {
          this.changeState();
        }

        window.SCX.setReactEnviroment();
      });
    });

    _defineProperty(this, "comunicate900Printed", num900 => {
      window.SCX.comunicate900Printed(num900);
    });

    _defineProperty(this, "get900", () => {
      if (this.props.forced900) {
        return this.props.forced900;
      }

      return window.SCX.get900();
    });

    _defineProperty(this, "onClick", () => {
      if (window.SCX && window.SCX.processC2C) {
        window.SCX.launchModalC2C();
      }
    });

    const loadjs = require('loadjs');

    let scxRoute = 'https://qa.cms.col.movistar.es/static/js/scx/scx.js';

    if ((0, _gerenciatdUtils2.findOutEnv)().name === 'prod') {
      scxRoute = 'https://prod.cms.col.movistar.es/static/js/scx/scx.js';
    }

    const myProps = (0, _gerenciatdUtils.setUpPropsByDevice)(props);
    const {
      applySam: _applySam,
      samActions: _samActions
    } = myProps;

    if (!window.SCX) {
      loadjs(scxRoute, {
        async: true
      });
    }

    this.state = {
      virtual900: null,
      kind: myProps.kind,
      label: myProps.label,
      view: myProps.view,
      ScxLoaded: false,
      color: myProps.color,
      print900: myProps.print900,
      applySam: _applySam,
      activateCMN: myProps.activateCMN,
      activateCML: myProps.activateCML,
      samActions: _samActions,
      visible: myProps.visible,
      myProps,
      phoneIcon: myProps.phoneIcon
    };
    this.printStates = ['SCX_CAMPAIGN_READY', 'WM_900_READY', 'SCX_CAMPAIGN_ERROR', 'SCX_BACKEND_REQUEST_ERROR'];
  }

  render() {
    const {
      myProps
    } = this.state;
    const {
      className,
      buttonProps,
      textProps,
      textPhoneNumberProps,
      taggingInfo,
      cySelector
    } = myProps;

    if (!taggingInfo.componentName) {
      taggingInfo.componentName = COMPONENT_NAME;
    }

    const ownCss = className ? ` ${className}` : '';
    const {
      virtual900,
      label,
      kind,
      view,
      color,
      activateCMN,
      activateCML,
      ScxLoaded,
      samActions,
      applySam,
      print900,
      segment,
      phoneIcon
    } = this.state;

    if (kind === KIND.PHONE) {
      if (!virtual900 || !window.SCX || !window.SCX.CMNTimeTableValid || !window.SCX.CMNTimeTableValid() || applySam && samActions['900'] === 'hide') {
        return null;
      }
      /* COMPLETING TAGGINGINFO IF NEEDED */


      taggingInfo.componentContent = _gerenciatdUtils3.CALL_4_SELLING_CONTENT.T900;

      if (view === 'button' && label) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, _objectSpread({
          cySelector: cySelector,
          className: `call4Selling call4Selling_button${ownCss}`,
          link: `tel:${virtual900}`,
          color: color,
          segment: segment,
          label: print900 ? `${label} ${virtual900}` : `${label}`,
          taggingInfo: taggingInfo,
          forceExternal: true,
          size: {
            w: _gerenciatdUnifiedcomponents.BUTTON_WIDTH.FULL
          }
        }, buttonProps));
      }

      const phoneLabel = ` ${virtual900}`;
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        "cy-data": cySelector,
        className: `call4Selling${ownCss}`,
        children: [phoneIcon && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedicons.default, {
          id: _gerenciatdUnifiedicons.ICONS_ID.Fijo,
          color: color,
          size: 20,
          kind: _gerenciatdUnifiedicons2.SVG_ICON_KIND.SOLID,
          className: "phoneIcon"
        }), label && textProps && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, _objectSpread(_objectSpread(_objectSpread({
          segment: segment
        }, myProps), textProps), {}, {
          text: label
        })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents3.default, {
          forceExternal: true,
          link: `tel:${virtual900}`,
          taggingInfo: taggingInfo,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, _objectSpread(_objectSpread(_objectSpread({
            color: color,
            segment: segment
          }, myProps), textPhoneNumberProps), {}, {
            text: phoneLabel
          }))
        })]
      });
    }

    if (!window.SCX || !window.SCX.CMNTimeTableValid() && !activateCML || applySam && samActions.c2c === 'hide' || window.SCX.CMNTimeTableValid() && !activateCMN) {
      return null;
    }

    if (view === 'button') {
      /* COMPLETING TAGGINGINFO IF NEEDED */
      taggingInfo.componentContent = _gerenciatdUtils3.CALL_4_SELLING_CONTENT.C2C;
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, _objectSpread({
        cySelector: cySelector,
        segment: segment,
        className: `call4Selling call4Selling_button${ownCss}`,
        onClick: this.onClick,
        color: color,
        label: label,
        taggingInfo: taggingInfo,
        size: {
          w: _gerenciatdUnifiedcomponents.BUTTON_WIDTH.FULL
        }
      }, buttonProps));
    }

    taggingInfo.componentContent = _gerenciatdUtils3.CALL_4_SELLING_CONTENT.C2C;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      "cy-data": cySelector,
      className: `call4Selling call4Selling_button${ownCss}`,
      onClick: this.onClick,
      onKeyPress: this.onClick,
      role: "button",
      tabIndex: "-1",
      children: label
    });
  }

}

Call4Selling.defaultProps = {
  phoneIcon: false,
  activateCML: false,
  activateCMN: true,
  applySam: true,
  samActions: {
    900: 'show',
    c2c: 'show'
  },
  color: PHONE_COLORS.WHITE,
  className: '',
  taggingInfo: {},
  buttonProps: {},
  textProps: {
    kind: 'span'
  },
  textPhoneNumberProps: {
    kind: 'span'
  },
  print900: true,
  visible: true,
  segment: SEGMENT.GP,
  cySelector: ''
};
Call4Selling.propTypes = {
  /**
   * {
   *  "info": "icono del telefono",
   *  "kind": "playground",
   *  "beautifulName": "icono del telefono"
   * }
   */
  phoneIcon: _propTypes.default.bool,

  /**
   * {
   *  "info": "Activar activateCallMeLater (CML)",
   *  "kind": "playground",
   *  "beautifulName": "Call Me Later"
   * }
   */
  activateCML: _propTypes.default.bool,

  /**
   * {
   *  "info": "Activar activateCallMeNow (CMN)",
   *  "kind": "playground",
   *  "beautifulName": "Call Me Now"
   * }
   */
  activateCMN: _propTypes.default.bool,

  /**
   * {
   *  "info": "Activar acciones SAM",
   *  "kind": "both",
   *  "beautifulName": "SAM"
   * }
   */
  applySam: _propTypes.default.bool,

  /**
   * {
   *  "info": "Mostrar barra 900",
   *  "kind": "both",
   *  "beautifulName": "900"
   * }
   */
  print900: _propTypes.default.bool,

  /**
   * {
   *  "info": "Definición de las acciones SAM a aplicar",
   *  "kind": "both",
   *  "beautifulName": "Acciones SAM"
   * }
   */
  samActions: _propTypes.default.object,

  /**
   * {
   *  "info": "Color del enlace del teléfono o del botón",
   *  "kind": "both",
   *  "beautifulName": "Color teléfono"
   * }
   */
  color: _propTypes.default.string,

  /**
   * {
   *  "info": "Segmento para definir carta de colores correspondiente",
   *  "kind": "both",
   *  "beautifulName": "segment"
   * }
   */
  segment: _propTypes.default.oneOf([SEGMENT.GP, SEGMENT.EMP]),

  /**
   * {
   *  "info": "Define la clase CSS custom que se aplicará al componente",
   *  "kind": "both",
   *  "beautifulName": "Estilos custom"
   * }
   */
  className: _propTypes.default.string,

  /**
   * {
   *  "info": "Permite contribuir la infomación que será enviada a analítica tras la interacción (objeto para el taggeado)",
   *  "kind": "both",
   *  "beautifulName": "Propiedades tagueo"
   * }
   */
  taggingInfo: _propTypes.default.object,

  /**
   * {
   *  "info": "Definición de las propiedades para el TextInfo que precede al número de teléfono, POR DEFECTO es un span",
   *  "kind": "both",
   *  "beautifulName": "Propiedades botón"
   * }
   */
  textProps: _propTypes.default.object,

  /**
   * {
   *  "info": "Cuando no hay botón, definición de las propiedades para el TextInfo del número de teléfono, POR DEFECTO es un span",
   *  "kind": "both",
   *  "beautifulName": "Propiedades botón"
   * }
   */
  textPhoneNumberProps: _propTypes.default.object,

  /**
   * {
   *  "info": "Definición de las propiedades para el botón",
   *  "kind": "both",
   *  "beautifulName": "Propiedades botón"
   * }
   */
  buttonProps: _propTypes.default.object,

  /**
   * {
   *  "info": "Visibiliza el componente",
   *  "kind": "both",
   *  "beautifulName": "Visible"
   * }
   */
  visible: _propTypes.default.bool,

  /**
   * {
   *  "info": "Indica si renderiza un botón o un número de teléfono",
   *  "kind": "both",
   *  "beautifulName": "View"
   * }
   */
  view: _propTypes.default.oneOf([VIEW_OPTIONS.BUTTON, VIEW_OPTIONS.PHONE]),

  /**
   * {
   *  "info": "número 900 'a fuego' que se quiere pintar",
   *  "kind": "both",
   *  "beautifulName": "forced900"
   * }
   */
  forced900: _propTypes.default.string,

  /**
   * {
   *  "info": "cySelector",
   *  "kind": "both",
   *  "beautifulName": "cySelector"
   * }
   */
  cySelector: _propTypes.default.string
};
var _default = Call4Selling;
exports.default = _default;

//# sourceMappingURL=index.js.map